import ResponseErrorHandling from "../../../../helper/ResponseErrorHandling";
import commonService from "../../../../services/Common/service";
import {
  ClientInfoActionTypes,
  CommonActionTypes,
} from "../../../action-types";

export const getClientAccounts = () => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.get("/client/mobile-home");
    const { data } = res;
    let mobiledata = null;

    if (data.success && data.data) {
      mobiledata = data.data;

      const accounts = Array.isArray(mobiledata.accounts)
        ? mobiledata.accounts
        : [];

      mobiledata.accounts_length = accounts.length;

      localStorage.setItem("clientInfo", JSON.stringify(mobiledata));
    }

    dispatch({
      type: ClientInfoActionTypes.CLIENT_INFO,
      payload: mobiledata,
    });
    return mobiledata;
  } catch (err) {
    const message = err.response.data.message || err.message;

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
